export var LegislativeItemAgendaDocumentsSourceType;
(function (LegislativeItemAgendaDocumentsSourceType) {
    LegislativeItemAgendaDocumentsSourceType["Document"] = "document";
    LegislativeItemAgendaDocumentsSourceType["Attachment"] = "attachment";
})(LegislativeItemAgendaDocumentsSourceType || (LegislativeItemAgendaDocumentsSourceType = {}));
